export const getFareDisplayPrice = (
  price_in_cents: number,
  base_price_in_cents: number
) => price_in_cents - base_price_in_cents;
